/* eslint-disable jsx-a11y/anchor-is-valid */
// eslint-disable-next-line jsx-a11y/anchor-is-valid
import React, { useContext } from 'react';
import { getHostCURL, PerksUrl } from '../../../common/utils/cardUtils';
import { handleFooterAnalytics } from '../../../common/utils/AnalyticsUtils';
import * as Constants from '../../../core/Constants';
import * as CardUtils from '../../../common/utils/cardUtils';
import { DataContext } from '../../../contexts';
import './ProXtraLinks.scss';

const analytics = Constants.analytics.FOOTER;

const PerksLink = () => (
  <a
    href={PerksUrl()}
    rel=" noreferrer"
    onClick={() => handleFooterAnalytics(analytics.PREFIX, analytics.Perks)}
  >
    <span className="ProXtraLinks__linkLabel">PERKS</span>
  </a>
);

const PricingLink = () => {
  return (
    <a
      href={getHostCURL('/myaccount/proXtraPricing')}
      rel=" noreferrer"
      onClick={() => handleFooterAnalytics(analytics.PREFIX, analytics.Pricing)}
    >
      <span className="ProXtraLinks__linkLabel">PRICING</span>
    </a>
  );
};

const OfferLink = () => {
  const isAdmin = CardUtils.getUserRole() === 'ADMIN';
  const benefitsLink = isAdmin ? getHostCURL('/myaccount/proxtraprogramdetails')
    : getHostCURL('/SpecialBuy/ProSpecialBuyOfTheWeek');
  return (
    <a
      href={benefitsLink}
      rel=" noreferrer"
      onClick={() => handleFooterAnalytics(analytics.PREFIX, analytics.Offer)}
    >
      <span className="ProXtraLinks__linkLabel">BENEFITS</span>
    </a>

  );
};

const RenderThreeFooterLinks = ({ linkList }) => {
  return (
    <div className=" ProXtraLinks__moreBox">
      <div className="col__4-12 ProXtraLinks__labelCenter">
        <div className="ProXtraLinks__labelBoxLine">
          {linkList.length >= 3 && linkList[0]}
        </div>
      </div>
      <div className="col__4-12">
        <div className="ProXtraLinks__labelBoxLine">
          {linkList.length >= 3 && linkList[1]}
        </div>
      </div>
      <div className="col__4-12">
        {linkList.length >= 3 && linkList[2]}
      </div>
    </div>
  );
};

const RenderTwoFooterLinks = ({ linkList }) => {
  return (
    <div className=" ProXtraLinks__moreBox">
      <div className="col__6-12 ProXtraLinks__labelCenter">
        <div className="ProXtraLinks__labelBoxLine">
          {linkList.length >= 2 && linkList[0]}
        </div>
      </div>
      <div className="col__6-12 ProXtraLinks__labelleft">

        {linkList.length >= 2 && linkList[1]}

      </div>
    </div>
  );
};

const RenderOneFooterLink = ({ linkList }) => {
  return (
    <div className=" ProXtraLinks__moreBox">
      <div className="col__12-12 ProXtraLinks__labelCenter">
        {linkList.length >= 1 && linkList[0]}
      </div>
    </div>
  );
};

const RenderProXtraLinks = ({ showingLink }) => {
  const linkList = [];
  const mapLinkListToRenders = () => {
    switch (linkList.length) {
    case 3: return <RenderThreeFooterLinks linkList={linkList} />;
    case 2: return <RenderTwoFooterLinks linkList={linkList} />;
    case 1: return <RenderOneFooterLink linkList={linkList} />;
    default: return <></>;
    }
  };

  const assembleLinkList = () => {
    if (showingLink.Perks) linkList.push(<PerksLink />);
    if (showingLink.Pricing) linkList.push(<PricingLink />);
    if (showingLink.Offer) linkList.push(<OfferLink />);
  };
  assembleLinkList();
  return mapLinkListToRenders();
};

export const ProXtraLinks = () => {
  const { userData } = useContext(DataContext);
  const { customerInfo } = userData || {};
  const { enrolledInPerksProgram, enrolledInPreferredPricing } = customerInfo || {};
  const showingLink = {
    Perks: enrolledInPerksProgram,
    Pricing: enrolledInPreferredPricing,
    Offer: enrolledInPerksProgram,
  };

  return <RenderProXtraLinks showingLink={showingLink} />;
};

export const exportsForTesting = {
  PerksLink,
  PricingLink,
  OfferLink,
  RenderThreeFooterLinks,
  RenderTwoFooterLinks,
  RenderOneFooterLink,
  RenderProXtraLinks,
};